import { RootState } from "../store";

export const account = (state: RootState) => state.account;

export const getRole = (state: RootState) => state.account.role;
